import React, { useState } from 'react';
import NavigationMenu from '../Components/Navigation/Navigation.tsx';
import './SearchBar.css';

const SearchBar: React.FC = () => {
    const [isFullScreen, setIsFullScreen] = useState(false);
    const [isMenuOpen, setIsMenuOpen] = useState(false);

    const handleSearchClick = () => setIsFullScreen(true);
    const handleCloseClick = () => setIsFullScreen(false);
    const handleOverlayClick = (e: React.MouseEvent) => {
        if (e.target === e.currentTarget) handleCloseClick();
    };

    return (
        <>
            {/* Regular search bar */}
            <div className="search-container">
                <img 
                    src="../SearchImages/profile.png" 
                    alt="Logo" 
                    className="logo" 
                    onClick={() => setIsMenuOpen(!isMenuOpen)}
                />

                <div className="search-bar" onClick={handleSearchClick}>
                    <input 
                        type="text" 
                        placeholder="Search For Products" 
                        className="search-input"
                        readOnly
                    />
                </div>

                <img src="../SearchImages/chat.png" className="chat-icon" onClick={() => window.location.href = "/chat"} />
                <img src="../SearchImages/flag.jpeg" className="flag-icon" />
            </div>

            {/* Fullscreen overlay */}
            {isFullScreen && (
                <div className="search-overlay" onClick={handleOverlayClick}>
                    <div className="search-full-container">
                        <div className="search-header">
                            <div className="input-wrapper">
                                <input 
                                    type="text" 
                                    placeholder="Search For Products" 
                                    className="search-input-full"
                                />
                                <button 
                                    className="cancel-btn"
                                    onClick={handleCloseClick}
                                >
                                    Cancel
                                </button>
                            </div>
                            <button className="close-btn" onClick={handleCloseClick}>×</button>
                        </div>

                        <div className="search-content">
                            <div className="popular-searches">
                                <h3>Popular search</h3>
                                <div className="currency-grid">
                                    {['EUR', 'GBP', 'AUD', 'BTC', 'ETH'].map((currency) => (
                                        <div key={currency} className="currency-item">
                                            {currency}
                                        </div>
                                    ))}
                                </div>
                            </div>

                            <div className="recent-searches">
                                <div className="recent-header">
                                    <h3>Recent view</h3>
                                    <button className="clean-btn">Clean</button>
                                </div>
                                <div className="no-records">No Records</div>
                            </div>
                        </div>
                    </div>
                </div>
            )}

            {isMenuOpen && <NavigationMenu toggleMenu={() => setIsMenuOpen(false)} isOpen={isMenuOpen} />}
        </>
    );
};

export default SearchBar;